import type { Benefit } from '../types/content';

export const symptoms = [
  'Hard starting or no-start conditions',
  'Low power',
  'Excessive smoke',
  'Fuel pressure concerns',
  'Injector issues',
  'Turbo and boost faults',
  'Sensor concerns',
  'DPF problems',
];

export const diagnosticAreas = ['Workflow', 'Fuel', 'Air & Boost', 'Electrical', 'Emissions', 'Advanced Cases'];

export const resourceTypes = [
  { title: 'Visual diagnostic workflows', text: 'Step-by-step layouts from complaint to verification.' },
  { title: 'Fault-finding sequences', text: 'Ordered checks that narrow down possible causes.' },
  { title: 'Testing guides', text: 'How each check fits into the investigation.' },
  { title: 'Diagnostic decision trees', text: 'What a result means for the next step.' },
  { title: 'Scan-data references', text: 'Organizing codes and live data for review.' },
  { title: 'Workshop tools & documentation sheets', text: 'Checklists, worksheets, and job records.' },
];

export const benefits: Benefit[] = [
  { title: 'Visual diagnostic resources', text: 'Find relevant diagrams and fault-finding references.' },
  { title: 'Structured diagnostic paths', text: 'Organize the progression from symptom to possible cause.' },
  {
    title: 'Six diagnostic areas',
    text: 'Consult workflow, fuel, air and boost, electrical, emissions, and advanced fault resources.',
  },
  {
    title: 'Reusable workshop references',
    text: 'Return to the guides and documentation tools when another diagnostic job arises.',
  },
];

export const offerIncludes = [
  '6 diagnostic volumes',
  '5 professional bonus resources',
  'Visual diagnostic workflows',
  'Fault-finding sequences',
  'Diesel testing guides',
  'Diagnostic decision trees',
  'Scan-data references',
  'Workshop worksheets and report templates',
];
